import { useLocation } from 'react-router-dom';
import { House, GearSix } from '@phosphor-icons/react';
import { NavLink } from '@/components/NavLink';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from '@/components/ui/breadcrumb';

/** Mapeamento de rotas para labels e icones */
const ROUTE_META: Record<string, { label: string; icon: typeof House }> = {
  '/dashboard': { label: 'Inicio', icon: House },
  '/settings': { label: 'Configurações', icon: GearSix },
};

/**
 * Breadcrumb contextual para paginas internas (dashboard, explore, profile, etc.).
 * Exibe "Dashboard / [Pagina Atual]" com links interativos.
 */
export function DashboardBreadcrumb() {
  const location = useLocation();
  const current = ROUTE_META[location.pathname];
  const is_home = location.pathname === '/dashboard';

  if (!current) return null;

  return (
    <Breadcrumb>
      <BreadcrumbList className="flex-nowrap">
        <BreadcrumbItem>
          {is_home ? (
            <BreadcrumbPage className="inline-flex items-center gap-1.5 text-xs">
              <House className="h-3.5 w-3.5" weight="regular" />
              <span>Dashboard</span>
            </BreadcrumbPage>
          ) : (
            <NavLink
              to="/dashboard"
              className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              <House className="h-3.5 w-3.5" weight="regular" />
              <span className="hidden sm:inline">Dashboard</span>
            </NavLink>
          )}
        </BreadcrumbItem>

        {!is_home && current && (
          <>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="inline-flex items-center gap-1.5 text-xs font-medium">
                <current.icon className="h-3.5 w-3.5" weight="regular" />
                <span>{current.label}</span>
              </BreadcrumbPage>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
